import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "./ui/button";
import { 
  Info, 
  Warning, 
  CheckCircle, 
  X,
  LockKey
} from "@phosphor-icons/react";

const VARIANTS = {
  info: {
    icon: Info,
    iconClass: "text-orange-1",
    buttonVariant: "secondary"
  },
  warning: {
    icon: Warning,
    iconClass: "text-orange-1",
    buttonVariant: "secondary"
  },
  success: {
    icon: CheckCircle,
    iconClass: "text-orange-1",
    buttonVariant: "secondary"
  },
  error: {
    icon: X,
    iconClass: "text-orange-1",
    buttonVariant: "secondary"
  },
  subscription: {
    icon: LockKey,
    iconClass: "text-orange-1",
    buttonVariant: "secondary"
  }
};

function InfoModal({ 
  isOpen, 
  onClose, 
  title, 
  description, 
  variant = "info",
  buttonText = "OK",
  onButtonClick = null
}) {
  const variantConfig = VARIANTS[variant] || VARIANTS.info;
  const IconComponent = variantConfig.icon;

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="p-4 bg-white text-background">
        <div className="text-center">
          <IconComponent 
            weight="duotone"
            className={`mx-auto mb-3 text-5xl ${variantConfig.iconClass}`} 
          />
          <p className="mb-2 text-2xl font-semibold leading-tight tracking-tight">
            {title}
          </p>
          <p className="mb-5 text-sm opacity-70">
            {description}
          </p>
          <Button
            onClick={handleButtonClick}
            variant={variantConfig.buttonVariant}
            className="w-full"
          >
            {buttonText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default InfoModal;
